// @ts-ignore
define("SDB.FindPerfectFit.View", [
  "sdb_find_perfect_fit.tpl",
  "SDB.FindPerfectFit.Model",
  "SDB.FindPerfectFit.Search.View",
  "SCView",
  "underscore",
], function (
  sdb_find_perfect_fit_tpl,
  SDBFindPerfectFitModel,
  _SDBFindPerfectFitSearchView,
  SCViewComponent,
  _
) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBFindPerfectFitView(options) {
    SCView.call(this);
    this.$ = SCView.prototype.$;
    this.render = SCView.prototype.render;
    this.listenTo = SCView.prototype.listenTo;

    this.model = SDBFindPerfectFitModel.getInstance();
    var env = options.container.getComponent("Environment");
    this.template = sdb_find_perfect_fit_tpl;
    this.options = options || {};

    if (env.getConfig("SDBFindPerfectFit.UseVehicleConfig")) {
      this.model.set("category", { name: "Vehicle", element: null });

      this.tabs = [
        { name: "Vehicle", id: "Vehicle", selected: false },
        { name: "Wheels", id: "Wheels", selected: false },
        { name: "Tires", id: "Tires", selected: false },
        // { name: 'Package', id: 'Package', selected: false }
      ];
    } else {
      this.model.set("category", { name: "Wheels", element: null });

      this.tabs = [
        { name: "Wheels", id: "Wheels", selected: false },
        { name: "Tires", id: "Tires", selected: false },
      ];
    }

    this.events = {
      'click [data-action="selected-category"]': "selectedCategory",
    };
    this.selectedCategory = function (e) {
      try {
        var $target = this.$(e.target);

        var category = $target.data("category");

        this.model.set("category", { name: category, element: $target });

        this.render();
      } catch (error) {
        console.error("Error selecting category", error);
      }
    };

    this.childViews = {
      "SDB.FindPerfectFit.Search.View": function SDBFindPerfectFitSearchView() {
        return new _SDBFindPerfectFitSearchView({
          container: this.options.container,
          model: this.model,
        });
      },
    };

    this.getName = function () {
      return this.model.get("category").name;
    };
    this.getImageURL = function () {
      var name = this.getName();
      var images = env.getConfig("SDBFindPerfectFit.Images");

      var imageObject = _.findWhere(images, { name: name });
      // return "https://canadacustomautoworks.com/wp-content/uploads/2020/10/cca-bg3.jpg";
      return imageObject ? imageObject.image : null;
    };

    this.getContext = function () {
      // @ts-ignore
      this.banner_image = this.getImageURL();
      this.name = this.getName();
      var tabs = this.tabs;
      // set selected tab to the actual tab being rendered
      _.each(tabs, function (tab) {
        tab.selected = false;
      });
      _.findWhere(tabs, { name: this.name }).selected = true;
      //end comment
      return {
        banner_image: this.banner_image,
        name: this.name,
        vehicleSelection: this.name === "Vehicle",
        makeSelection: this.name === "Package",
        tabs: tabs,
        name_lower_case: this.name.toLowerCase(),
      };
    };
  }

  SDBFindPerfectFitView.prototype = Object.create(SCView.prototype);
  SDBFindPerfectFitView.prototype.attributes = {
    id: "SDBFindPerfectFitViewId",
    class: "sdb-find-perfect-fit-view",
  };
  SDBFindPerfectFitView.prototype.constructor = SDBFindPerfectFitView;

  return SDBFindPerfectFitView;
});
